module.exports = __webpack_public_path__ + "static/media/xstock.56263b20.svg";